module.exports = __webpack_public_path__ + "img/App_qrcode_en.2c0c3c53.jpg";